<script setup>

</script>

<template>
  <section class="block-container">
    <slot/>
  </section>
</template>

<style scoped lang="scss">
.block-container {
  width: min(1200px, calc(100% - 32px));
  margin: 28px auto 0;
  padding: 28px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  gap: 24px;
  align-items: center;
}

@media (max-width: 900px) {
  .block-container {
    grid-template-columns: 1fr;
    padding: 20px;
  }
}
</style>